
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16-2h2v4h-2v-4zm4 1h2v3h-2v-3zM10 3h18v4h2c1.645 0 3 1.355 3 3v3c0 1.645-1.355 3-3 3h-2v5c0 1.645-1.355 3-3 3H13c-1.645 0-3-1.355-3-3V3zm2 2v16c0 .555.445 1 1 1h12c.555 0 1-.445 1-1V5H12zm16 4v5h2c.555 0 1-.445 1-1v-3c0-.555-.445-1-1-1h-2z"}})])
          )
        }
      }
    